import { Button } from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';

import { OnboardingStep } from '../OnboardingStep';
import { StepFormContextProvider } from '../../provider';
import { CompanyRepresentatives } from '../forms';

type Props = unknown;

/**
 * OnboardingExistingCompanyRepresentatStep.
 * Step that renders the form for the representant of the company.
 * It is splitted on purpose, to keep the form agnostic.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function OnboardingExistingCompanyRepresentatives(): JSX.Element {
  const i18nGeneral = useTranslations('General');
  const i18nRepresentantInformationsStep = useTranslations(
    'OnboardingExistingRepresentantInformationsStep',
  );

  const navigate = useNavigate();

  const { companyId = '' } = useParams();

  const handleStepSubmit = (): void => {
    navigate(routes.onboardings.company.owners.fmt(companyId));
  };

  const handleStepCancel = (): void => {
    navigate(routes.onboardings.company.infos.fmt(companyId));
  };

  return (
    <StepFormContextProvider>
      <OnboardingStep
        subTitle={i18nRepresentantInformationsStep('SubTitle')}
        title={i18nRepresentantInformationsStep('Title')}
      >
        <CompanyRepresentatives onCancel={handleStepCancel} onSubmit={handleStepSubmit} />
        <Button key="cancel" variant="secondary" w="full">
          {i18nGeneral('Back')}
        </Button>
        <Button key="submit" data-cy="next" w="full">
          {i18nGeneral('Next')}
        </Button>
      </OnboardingStep>
    </StepFormContextProvider>
  );
}

export type OnboardingExistingCompanyRepresentativesProps = Props;
